export const ACTION_TYPES = {
	PENDING_APPROVALS_INIT: 'PENDING_APPROVALS_INIT',
	PENDING_APPROVALS_SET_ROWS: 'PENDING_APPROVALS_SET_ROWS',
	PENDING_APPROVALS_TOGGLE_ROW: 'PENDING_APPROVALS_TOGGLE_ROW',
	PENDING_APPROVALS_TOGGLE_ALL: 'PENDING_APPROVALS_TOGGLE_ALL',
	PENDING_APPROVALS_SEARCH_INDEX: 'PENDING_APPROVALS_SEARCH_INDEX',
	PENDING_APPROVALS_SORT_BY_HEADER: 'PENDING_APPROVALS_SORT_BY_HEADER',
	PENDING_APPROVALS_FILTER_BY_USER: 'PENDING_APPROVALS_FILTER_BY_USER',
};
